import { detect, fromHtmlTag } from "@lingui/detect-locale";
import type { ClientAppConfig } from "src/context/AppConfigProviderContext.tsx";
import eik from "../../eik.json" with { type: "json" };

export const addTrackJSMetadata = ({ env, locale }: ClientAppConfig) => {
  if (typeof window !== "undefined" && window.TrackJS) {
    const lang = detect(fromHtmlTag("lang"), locale) || locale;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    window.TrackJS.addMetadata("pkgName", eik.name);
    window.TrackJS.addMetadata("pkgVersion", eik.version);
    window.TrackJS.addMetadata("env", env);
    window.TrackJS.addMetadata("lang", lang);
    window.TrackJS.addMetadata("timezone", timezone);
  }
};
